import { render, staticRenderFns } from "./CouponEmpty.vue?vue&type=template&id=79b947ab&scoped=true&"
import script from "./CouponEmpty.vue?vue&type=script&lang=js&"
export * from "./CouponEmpty.vue?vue&type=script&lang=js&"
import style0 from "./CouponEmpty.vue?vue&type=style&index=0&id=79b947ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b947ab",
  null
  
)

export default component.exports